const CREATE_CART_WITH_GIFTCARD_QUERY = `
  mutation cartCreate($input: CartInput!) {
    cartCreate(input: $input) {
      cart {
        appliedGiftCards {
          balance {
            amount
            currencyCode
          }
        }
      }
      userErrors {
        field
        message
      }
    }
  }
`
const selectors = {
  'cardPin': '#giftcardCheck',
  'cardBalance': '[data-cardBalance]'
}

//dynamic click event
document.addEventListener('click', (event) => {
  if (event.target.hasAttribute('data-searchBalance')) {
    const cardNum = document.querySelector(selectors.cardPin).value;

    getCardBalance(cardNum)
  }
})

/**
 *  checking remaining card balance
 *
 */

getCardBalance = async (cardNumber) => {
  const result = await fetch(`https://${window.Shopify.shop}/api/2025-01/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': window.globalVariables.storefrontAccessToken
    },
    body: JSON.stringify({
      query: CREATE_CART_WITH_GIFTCARD_QUERY,
      variables: {
        input: {
          giftCardCodes: [cardNumber]
        }
      }
    })
  }).then(res => res.json())

  const giftCards = (result.data?.cartCreate?.cart?.appliedGiftCards || [])

  displayBalance(giftCards)
}

displayBalance = (giftCards) => {
  if (giftCards.length >= 1) {
    giftCards.forEach(giftCard => {
      const remainingBalance = Shopify.formatMoney(Number(giftCard.balance.amount || 0) * 100, window.globalVariables.money_format);
      const remainingBalanceText = window.giftCard.remainingBalance.replace("${remainingBalance}", remainingBalance)
      document.querySelector(selectors.cardBalance).innerHTML = `<span>${remainingBalanceText}</span>`
    });
  }
  else {
    document.querySelector(selectors.cardBalance).innerHTML = `<span>${window.giftCard.cardnotfound}</span>`
  }
}
